import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 576A1B80-550B-46BD-90A6-A497D8A29BC5
 * name vector-arrange-above
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-arrange-above.svg
 * tags
 * - Vector 
 * - Arrange 
 * - Geographic Information System 
 */
export const VectorArrangeAboveIcon = createSvgIcon(<><path d="M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C6.67,16 10.33,16 14,16C15.11,16 16,15.11 16,14C16,10.33 16,6.67 16,3C16,1.89 15.11,1 14,1H3M3,3H14V14H3V3M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18Z" /></>, 'VectorArrangeAboveIcon');
export default VectorArrangeAboveIcon